module.exports = __webpack_public_path__ + "img/order-detail-content-bg.0a2ffaf3.png";